import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './ManagerExternalConnection.module.scss';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import { useWorkplaceExternalConnectionQuery } from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';
import {
	updateWorkplaceData,
	WorkplaceUpdateData,
} from '../../../../Services/workplaceUpdate.service';
import useFilters from '../../../../../Base/Hooks/useFilters';

const FORM_SCHEME: ItemScheme[] = [
	{
		type: MagicField.DOCTOR_SELECT,
		key: 'defaultDoctorId',
		title: 'component.externalConnection.defaultDoctorId',
		settings: {
			tooltip: {
				content: 'component.externalConnection.defaultDoctorIdTooltip',
			},
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'defaultInvitation',
		title: 'component.externalConnection.defaultInvitation',
		settings: {
			tooltip: {
				content: 'component.externalConnection.defaultInvitationTooltip',
			},
		},
	},
];

interface Props {
	workplaceId: string;
}

const ManagerExternalConnection: React.FC<Props> = ({ workplaceId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const {
		data,
		isLoading: isLoadingBasicData,
		refetch,
	} = useWorkplaceExternalConnectionQuery({
		id: workplaceId,
	});
	const { displayError } = useApiClient();
	const { checkEmptyString } = useFilters();

	const defaultData = useMemo(() => {
		const workplace = data?.workplace;
		if (workplace) {
			return {
				...workplace,
				defaultDoctorId: workplace.defaultDoctorId
					? { value: workplace.defaultDoctorId }
					: undefined,
			};
		}

		return undefined;
	}, [data]);

	const handleSubmit = async (values: any) => {
		setIsLoading(true);
		const { defaultInvitation, defaultDoctorId } = values;

		const data: WorkplaceUpdateData = {
			defaultDoctorId: checkEmptyString(defaultDoctorId?.value) ?? null,
			defaultInvitation,
		};

		try {
			const response = await updateWorkplaceData(workplaceId, data);
			if (response.status === 200) {
				await refetch();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading || isLoadingBasicData) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className='row'>
				<div className='col-12 col-md-4'>
					<MagicForm
						formScheme={FORM_SCHEME}
						onSubmit={handleSubmit}
						defaultValues={defaultData}
					/>
				</div>
			</div>
		</div>
	);
};

export default ManagerExternalConnection;
